import { styled } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { useCheckoutRetailer } from "../../hooks/useCheckoutRetailer";
import { CheckoutConnectRetailer } from "./CheckoutConnectRetailer";
import { useState } from "react";
import { saveRetailerCredentials } from "@/api/rest/checkoutApi";

const RetailerStatusContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0",
  borderRadius: "8px",
  backgroundColor: "#fff",
});

export const RetailerLoginForm = () => {
  const { currentRetailer } = useCheckoutRetailer();

  const [state, send] = useCheckoutUI();

  const [submitting, setSubmitting] = useState<boolean>(false);

  const { checkoutIntent } = state.context;

  if (!currentRetailer) {
    return null;
  }

  const onSaveCredentials = async (username: string, password: string) => {
    setSubmitting(true);
    try {
      const checkoutIntent = await saveRetailerCredentials({
        retailerId: currentRetailer?.retailerId.toString(),
        checkoutIntentId: state.context.checkoutIntent?.checkoutIntentId!,
        credentials: {
          username,
          password,
        },
      });
      send({
        type: "SET_CHECKOUT_INTENT",
        data: { checkoutIntent },
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <RetailerStatusContainer>
      <div>
        {`Connect your ${
          currentRetailer?.displayName || "retailer"
        } account to earn rewards
and get expedited shipping`}
      </div>
      <CheckoutConnectRetailer
        onSaveCredentials={onSaveCredentials}
        usernameFromCheckoutIntent={
          checkoutIntent?.retailerConnection?.username
        }
        passwordHashFromCheckoutIntent={
          checkoutIntent?.retailerConnection?.passwordHash
        }
        submitting={submitting}
      />
    </RetailerStatusContainer>
  );
};
